module.exports = __webpack_public_path__ + "static/icon-banner-placeholder-7a4d2a175eeace64d37f967613c6ab6a.png";